<template>
  <div v-if="data" class="modal__body" :class="{ 'modal__body--assignment': typeAssignment == TypeAssignment.AssignedUser }">
    <section class="card radial">
      <radial-chart :value="data.progress.percent?.toFixed(2)" label="Gestion total" percent />

      <span class="progress">{{ strategyProgress }}</span>
    </section>

    <section class="card card--stat">
      <div class="card__icon">
        <img :src="phoneCheckImage" alt="check" />
      </div>
      <div class="card__value">{{ data.calls_statistics.answered }}</div>
      <span>Contestada</span>
    </section>

    <section class="card card--stat">
      <div class="card__icon">
        <img :src="phoneNoneImage" alt="none" />
      </div>
      <div class="card__value">{{ data.calls_statistics.no_contact }}</div>
      <span>No contactado</span>
    </section>

    <!-- <section class="card">
      <div class="card__title">Agentes</div>
      <dashboard-agents :agents="data.agents" />
    </section>

    <section class="card">
      <span class="card__title"> Estado de agentes </span>
      <agents-status-chart :data="data.agents_statistics" progressive />
    </section> -->

    <section class="card">
      <span class="card__title"> Resultado de gestiones </span>
      <CustomScrollbar height="355px">
        <management-result-chart :stats="data.management_statistics" />
      </CustomScrollbar>
    </section>
    <section class="card" v-if="typeAssignment == TypeAssignment.AssignedUser" >
      <div class="card__title">
        Usuarios asignados ({{data.user_progress.length}})
        <a-tooltip>
          <template #title>
            Los usuarios que terminen su progreso, no seguirán asignados a la estrategia. Podrán participar en nuevas estrategias.
          </template>

          <InfoCircleOutlined class="icon" />
        </a-tooltip>
      </div>
      <dashboard-agents :agents="data.user_progress" is-progressive />
    </section>
  </div>
</template>

<script>
import { inject } from "vue";

import RadialChart from "@/app/strategies/components/charts/RadialChart.vue";
import ManagementResultChart from "@/app/strategies/components/charts/ManagementResultChart.vue";
// import AgentsStatusChart from "@/app/strategies/components/charts/AgentsStatusChart";
// import DashboardAgents from "@/app/strategies/components/tables/DashboardAgents";
import { TypeAssignment } from "@/app/shared/utils/enums";

import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";

import phoneCheckImage from "@/app/strategies/assets/phone_check.svg?url";
import phoneNoneImage from "@/app/strategies/assets/phone_none.svg?url";
import DashboardAgents from "@/app/strategies/components/tables/DashboardAgents.vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";

export default {
  components: {
    RadialChart,
    ManagementResultChart,
    // AgentsStatusChart,
    DashboardAgents,
    CustomScrollbar,
    InfoCircleOutlined,
  },
  props: {
    data: {
      required: false,
      type: Object,
      default: null,
    },
    typeAssignment: {
      required: false,
      type: Object,
      default: null,
    },
  },
  setup() {
    const strategyProgress = inject("strategyProgress");

    return { strategyProgress, phoneCheckImage, phoneNoneImage, TypeAssignment };
  },
};
</script>

<style lang="sass" scoped>
@import '@/sass/main'

.modal
  &__body
    color: $gray-9
    height: 400px
    display: grid
    // grid-template-columns: repeat(6, 1fr)
    // grid-template-columns: repeat(6, 1fr)
    // grid-template-columns: 1fr 1fr 1.5fr 1fr 1fr
    grid-template-columns: 1fr 1fr 1.5fr
    // grid-template-rows: repeat(6, 1fr)
    grid-template-rows: repeat(2, 1fr)
    gap: 12px
    &--assignment
      grid-template-columns: 1fr 1fr 1.5fr 1fr 1fr

  &__picker
    margin-bottom: 12px

  &__paragraph
    margin: 16px 0

.radial
  display: grid
  place-content: center

  .progress
    text-align: center

.card
  border: $border-normal
  border-radius: 2px
  padding: 12px 8px

  &__title
    font-weight: 600
    margin-bottom: 12px

  &__icon
    font-size: 32px
    margin: 4px 0

    & img
      display: block
      margin: 6px 0
      height: 36px

  &__value
    font-size: 30px
    line-height: 38px
    margin-bottom: -4px

  &--stat
    display: flex
    flex-direction: column
    align-items: center

  &:nth-child(1)
    grid-column: 1 / 3
    // grid-row: 1 / 3

  &:nth-child(2)
    grid-column: 1 / 1
    // grid-row: 3 / 5

  &:nth-child(3)
    grid-column: 2 / 2
    // grid-row: 3 / 5

  &:nth-child(4)
    grid-column: 3 / 4
    // grid-row: 1 / 7
    grid-row: 1 / 3

  &:nth-child(5)
    grid-column: 4 / 7
    // grid-row: 1 / 4
    grid-row: 1 / 3

  &:nth-child(6)
    grid-column: 5 / 7
    // grid-row: 4 / 7
</style>
